<template>
  <div class="wrap">
    <!-- <p class="back" @click="$router.back()">返回</p> -->
    <!--添加调查员-->
    <div class="flex">
      <div class="left" :style="{ flex:'auto',width: 'calc(100% - 330px)' }">
        <div style="height: calc(100vh - 130px); overflow: auto" class="pt-4">
          <add-visitor :type="infoType" @childData="getChildData" @changeDialog="personDialog"></add-visitor>
          <div class="sample-component">
            <AddSampleList num="2." :currentPage="currentPage" :isHaveTask="isHaveTask" :activeCallType="activeCallType" @selectionChangeEmit="selectionChangeEmit" ref="addSampleList"/>
          </div>
          <div class="assignTask px-6" v-loading="fullscreenLoading">
            <!-- 任务信息 -->
            <div class="info mb-4">
              <div class="top mb-4 mt-4 font-bold font-style">3.设置任务</div>
              <div class="flex-container">
                <div class="info task-info">
                  <el-form ref="taskInfo" :model="taskInfo" :rules="taskInfoRules" label-width="90px" label-position="right">
                    <el-row :gutter="6">
                      <el-col :span="12">
                        <el-form-item label="任务名称:" prop="executionName">
                          <el-input placeholder="请输入任务名称" v-model="taskInfo.executionName" autocomplete="off"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item prop="executionValidateTo" label="截止时间:">
                          <el-date-picker
                            class="el-form-input"
                            type="datetime"
                            placeholder="选择日期"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            v-model="taskInfo.executionValidateTo"
                            :picker-options="startDateDisabled"
                            style="width:100%"
                          />
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-col :span="24">
                      <el-form-item label="描述:">
                        <el-input placeholder="请输入描述" v-model="taskInfo.executionDescription"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="执行要求:" prop="executionRequirement">
                        <el-input placeholder="请输入执行要求" v-model="taskInfo.executionRequirement" autocomplete="off"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="质控标准:" prop="qualityControlStandard">
                        <el-input placeholder="请输入质控标准" v-model="taskInfo.qualityControlStandard" autocomplete="off"></el-input>
                      </el-form-item>
                    </el-col>
                    <!-- <el-col :span="24">
                      <el-form-item label="结算标准:" prop="settleStandard">
                        <el-input placeholder="请输入质控标准" v-model="taskInfo.settleStandard" autocomplete="off"></el-input>
                      </el-form-item>
                    </el-col> -->
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="submit-btn p-4 pl-6 pr-6">
          <!-- <div class="footer-text">
            调查员预计到手金额<span class="price-style">{{ estimatedCost || '--' }}</span> 元(不包含阶梯计价)，若采用线上结算，项目预计花费<span class="price-style">{{ actualCost || '--' }}</span> 元
            <el-tooltip
              effect="dark"
              :content="`项目预计费用=预估费用*（1+${accRate}），其中${accountingRateVal}为用于调查员待缴税及平台技术服务费`"
              placement="top"
            >
              <div class="icon-wrap">
                <span class="icon-font ico-tips">&#xe65b;</span>
              </div>
            </el-tooltip>
          </div> -->
          <div class="footer-text flex">
            <div class="flex mr-10" v-show="actualCost>0">
              线上结算预估花费:
              <el-tooltip
                effect="dark"
                :content="`项目预计费用=预估费用*（1+${accRate}），其中${accountingRateVal}为用于调查员待缴税及平台技术服务费`"
                placement="top"
              >
                <div class="icon-wrap">
                  <span class="icon-font ico-tips">&#xe65b;</span>
                </div>
              </el-tooltip>
              <span class="total ml4">{{actualCost}}</span>
            </div>
            <div class="flex" v-show="estimatedCost > 0">
              线下结算预估花费:
              <el-tooltip
                effect="dark"
                content="线下与调查员协商支付方式，纳税事宜，该金额为预估花费"
                placement="top"
              >
                <div class="icon-wrap">
                  <span class="icon-font ico-tips">&#xe65b;</span>
                </div>
              </el-tooltip>
              <span class="total ml4">{{estimatedCost}}</span>
            </div>

          </div>




          <div class="btn-footer">
            <el-button @click="$emit('cancel')" style="width: 88px">取消</el-button>
            <el-button type="primary" @click="handleSubmit" style="width: 88px">确认</el-button>
          </div>
        </div>
      </div>
      <div class="right px-4 bg-card-bg-gray" :style="{ width: '290px',flex:'none'}">
        <div :style="{ overflow:'auto',height:'calc(100vh - 78px)' }">
          <Advert></Advert>
        </div>
      </div>
    </div>

    <el-dialog class="theme-dialog" :visible.sync="dialogVisibleRepeat" width="30%" :modal="false">
      <template slot="title">
        <div>
          <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer" style="color: #e6a23c"></i>
          <span style="margin-left: 5px">重复号码提醒</span>
        </div>
      </template>
      <p>
        {{ repeatPhone }}等共计{{ repeatLen }}个号码，<span style="color: rgb(240, 65, 52)">在输入框中重复，已为您自动去重</span
        >，请重新提交。
      </p>
      <!-- <el-input v-model="delTip" style="margin-top: 20px" placeholder="请输入内容"></el-input> -->
      <span slot="footer">
        <el-button style="margin-left: 25px; margin-top: 5px" @click="seeRepeat">查看重复</el-button>
        <el-button type="primary" style="margin-left: 30px; margin-top: 5px" @click="dialogVisibleRepeat = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog class="theme-dialog" :visible.sync="dialogVisibleRepeat1" width="30%" :modal="false">
      <template slot="title">
        <div>
          <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer" style="color: #e6a23c"></i>
          <span style="margin-left: 5px">重复样本号码提醒</span>
        </div>
      </template>
      <p>
        {{ checkPhone1 }}，<span style="color: rgb(240, 65, 52)">以上号码已在本问卷其他任务中存在</span>，你要删除这些号码吗？
      </p>
      <!-- <el-input v-model="delTip" style="margin-top: 20px" placeholder="请输入内容"></el-input> -->
      <span slot="footer">
        <el-button style="margin-left: 25px; margin-top: 5px" @click="seeCheck">重复添加</el-button>
        <el-button type="primary" style="margin-left: 30px; margin-top: 5px" @click="delCheck">删 除</el-button>
      </span>
    </el-dialog>
    <OnlinePayService ref="onlinePayServiceVisible" />
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      append-to-body
      width="30%"
      :before-close="handleDialogClose">
      <span>这尚未开通费用结算，无法设定线上结算，请前往开通</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialogClose">取 消</el-button>
        <el-button type="primary" @click="toOpen">去开通</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { isNum } from '@/assets/js/utils'
import { getCheckPhone } from '@/api/wenjuan/offline'
import { creatPhoneTask, checkPhoneList } from '@/api/wenjuan/telephone'
import { mapGetters } from 'vuex'
import { peopleList, plCreat, checkUser } from '@/api/wenjuan/addList'
import intersection from 'lodash.intersection'
import uniq from 'lodash.uniq'
import differenceby from 'lodash.differenceby'
import differenceWith from 'lodash.differencewith'
import isEqual from 'lodash.isequal'
import AddVisitor from '@/components/interview/add-visitor/add-visitor'
import { isMobile, isLandline } from '@/assets/js/validate'
import OnlinePayService from '@/components/online-pay-service'
import GlobalConfig from '@/global/config'
import * as XlsxUtil from '@/assets/js/XlsxUtil'
import Advert from '@/components/interview/advert/index.vue'
import AddSampleList from '@/views/survey/offline/components/drawer/AddSampleList'
const testNum = /((^[0-9]\d*)|^0)(\.\d{0,2})?$/
const moneyRule = /(^[\-0-9][0-9]*(.[0-9]+)?)$/
export default {
  components: {
    AddVisitor,
    OnlinePayService,
    Advert,
    AddSampleList
  },
  name: 'assignTask',
  props: {
    activeCallType: {
      type: [String, Number],
      default: null
    },
    isHaveTask: {
      type: Boolean,
      default: false
    }
  },
  created() {
    let len = this.$route.query.len || 1
    this.taskInfo.executionName = this.title + len // '电话访问' + len
    // this._initPromise()
  },
  data() {
    const executionNameRules = (rule, value, callback) => {
      let v = this.taskInfo.executionName
      if (!v.trim()) {
        callback(new Error('请输入任务名称'))
      }
      callback()
    }
    const executionValidateToRules = (rule, value, callback) => {
      let v = this.taskInfo.executionValidateTo
      if (!v) {
        callback(new Error('请选择结束时间'))
      }
      callback()
    }
    const startDateDisabled = {}
    startDateDisabled.disabledDate = function (time) {
      return time.getTime() + 24 * 3600 * 1000 < Date.now()
    }
    return {
      dialogVisible: false,
      GlobalConfig,
      loading: false,
      fullscreenLoading: false,
      checkPhone1: [],
      repeatAllArr: [],
      repeatPhone: '', //用来显示的重复的手机号
      repeatLen: '', //用来显示的重复的手机号的长度
      sampleStr: '', // 存放样本手机号字符串
      sampleStr1: [], // 存放样本手机号的数组
      startDateDisabled,
      hasCheck: [],
      // flag: 2,
      dialogVisibleRepeat: false,
      dialogVisibleRepeat1: false,
      executionBy: '',
      visitorInfo: {
        executorPhone: ''
      },
      taskInfo: {
        executionName: ''
        // executionValidateTo: '',
        // executionQuantity: 0,
        // executionSingleAmount: 0,
        // executionDescription: ''
      },
      taskInfoRules: {
        executionName: [{ required: true, validator: executionNameRules, trigger: 'blur' }],
        executionValidateTo: [{required: true, validator: executionValidateToRules,trigger: 'blur'}],
        // qualityControlStandard:[{ required: true, message:'请输入质控标准', trigger: 'blur' }]
      },
      // promiseCb: null,
      // promise: null,
      childVal: [], //子组件传来的值 包含已添加的调查员信息
      infoType: 'phone',
      estimatedCost: 0, //预估费用
      actualCost: 0, // 实际金额
      tableData: [],
      currentPage: 'telephoneInterviewer'
    }
  },
  computed: {
    // 输入框下面显示条数
    zidongArr1Length() {
      if (this.zidongArr1 == '') {
        return 0
      } else {
        const a = this.zidongArr1.split('\n')
        //  console.log(a.length);
        return a.length
      }
    },
    // 存放样本手机号数组
    sampleArr() {
      // this.errSamplePhoneIndex=[]
      if (this.sampleStr == '') {
        return []
      } else {
        // console.log(this.sampleStr);
        this.sampleStr1 = this.sampleStr.split('\n')
        const ybArr = []
        this.ybArrLen = 0
        // console.log(this.sampleStr1);
        this.sampleStr1.forEach((el, index) => {
          // if((isMobile(el) || isPhone(el))){
          console.log('su', el)
          let elArr = el.split(/[，,]/g)
          console.log(elArr)
          ybArr.push(elArr)

          // }else{
          //   console.log('fa',el);
          //   this.ybArrLen += 1
          //   // this.errSamplePhoneIndex.push(index+1);
          // }
        })
        // console.log(ybArr);
        return ybArr
      }
    },
    sampleLength() {
      // console.log("len",this.sampleArr.length);
      return this.sampleArr.length
    },
    money() {
      this.taskInfo.executionQuantity = this.sampleArr.length
      let { executionQuantity = 0, executionSingleAmount = 0 } = this.taskInfo
      return ((executionQuantity * 100 * executionSingleAmount) / 100 || 0).toFixed(2)
    },
    ...mapGetters(['title']),
    exPhone() {
      return this.zidongArr1
    },
    accountingRateVal() {
      const { accountingRate = 0 } = this.$store.getters || {};
      return accountingRate === null || accountingRate === 0 ? '6.5%' : `${accountingRate}%`
    },
    accRate() {
      const { accountingRate = 0 } = this.$store.getters || {};
      return accountingRate === null || accountingRate === 0 ? '0.065' : (accountingRate / 100).toFixed(3)
    }
  },
  watch: {
    exPhone(newValue, oldValue) {
      newValue ? (this.isActive = true) : (this.isActive = false)
    }
  },
  methods: {

    computedTotal(data){
      let total = 0
      data.forEach(item => {
        if (item.settleRule.unitPriceYuan && item.settleRule.expectedQuantity) {
          total += item.settleRule.unitPriceYuan * item.settleRule.expectedQuantity
        } else {
          total += 0
        }
      })
      return total;
    },
    //拿到添加的调查员信息
    getChildData(data) {
      this.childVal = data
      // settleMethod  0 线上  1 线下
      // 线上数据集合
      const onlineDataList = data.filter(it=> it.settleMethod === 0 && [1,2].includes(it.settleMode))
      //线下数据集合
      const offlineDataList = data.filter(it=> it.settleMethod === 1 && [1,2].includes(it.settleMode))

      const onlineTotal = this.computedTotal(onlineDataList);
      const offlineTotal = this.computedTotal(offlineDataList);
      // 线上计算结果
      const acc_rate = parseFloat(this.accRate)
      this.actualCost = isNaN(((1 + acc_rate) * onlineTotal).toFixed(2)) ? 0 : ((1 + acc_rate) * onlineTotal).toFixed(2)
      // 线下计算结果
      this.estimatedCost = isNaN(offlineTotal.toFixed(2)) ? 0 : offlineTotal.toFixed(2)
    },
    seeCheck() {
      // console.log(this.hasCheck);
      this.dialogVisibleRepeat1 = false
      // this.flag = 1
      this.creatTask()
    },
    delCheck() {
      // console.log(this.hasCheck);
      let check = this.hasCheck
      // console.log(this.sampleArr);
      this.sampleArr.map((item, idx) => {
        for (let index = 0; index < check.length; index++) {
          if (check[index] == item[0]) {
            this.sampleArr.splice(idx, 1)
          }
        }
      })
      this.sampleStr = this.sampleArr.join('\n')
      this.dialogVisibleRepeat1 = false
    },
    seeRepeat() {
      let sheet = [['重复手机号']]
      let arr = this.repeatAllArr
      for (let index = 0; index < arr.length; index++) {
        sheet.push([arr[index]])
      }
      XlsxUtil.downloadXlsx([sheet], { filename: '重复号码清单' })
    },
    getReaptePhone() {
      let checkPhone = this.sampleArr.map(el => {
        return el[0]
      })
      // console.log(checkPhone);
      const p = {
        surveyId: GlobalConfig.getSurveyId(),
        phoneList: checkPhone
      }
      return checkPhoneList(p)
    },
    creatTask() {
      let validFlag = true
      this.childVal.forEach(it => {
        if (it.settleMode === 3 && it.settleMethod!=2) {
          it.settleRule.tiers.forEach((itTiers, indexTiers, arrTiers) => {
            itTiers.quantityLowerBound =
              indexTiers > 0 ? arrTiers[indexTiers - 1].quantityUpperBound + 1 : itTiers.quantityLowerBound
            if (itTiers.quantityUpperBound === undefined || itTiers.unitPriceYuan === undefined) {
              validFlag = false
            }
          })
        } else if ((it.settleMode === 1 || it.settleMode === 2)&&it.settleMethod!=2) {
          if (it.settleRule.expectedQuantity === undefined || it.settleRule.unitPriceYuan === undefined) {
            validFlag = false
          }
        }
      })
      if (!validFlag) {
        this.$message.error('请完善表单项')
        return
      }
      let list = this.childVal.map(item => {
        return {
          userId: item.id,
          userName: item.name ? item.name : '',
          phone: item.phone,
          justForCode: item.justForCode ? item.justForCode : false,
          settleMethod: item.settleMethod || 0,
          settleMode: item.settleMode || '',
          settleRule: item.settleRule || {}
        }
      })
      // let phoneList = this.sampleArr.map(el => {
      //   return {
      //     phoneNumber: el[0],
      //     sampleName: el[1]
      //   }
      // })
      if(this.$refs.addSampleList.tableData && this.$refs.addSampleList.tableData.length>0 || this.activeCallType === 5 && this.isHaveTask){
        let params = {
          execution: {
            surveyId: GlobalConfig.getSurveyId(),
            ...this.taskInfo,
            userList: list,
          },
          jobFrom: this.$refs.addSampleList.callType,
          phoneList: [],
          // tableData:this.tableData
        }
        //如果添加预测式外呼任务且已经有过预测式外呼任务，调用 /addPhoneList 这个接口时不传 sampleDetails。为了用户能自己加调查员。
        if( !(this.activeCallType === 5 && this.isHaveTask) ) {
          params.sampleDetails = {
            tableData: this.$refs.addSampleList.tableData,
            type : this.$refs.addSampleList.type,
            group : this.$refs.addSampleList.group,
            groupName : this.$refs.addSampleList.groupName,
            checkedSeetingFields: this.$refs.addSampleList.checkedSeetingFields,
            checkBoxData: this.$refs.addSampleList.checkBoxData,
          }
        }
        this.fullscreenLoading = true
        creatPhoneTask(params)
          .then(res => {
            if (res.data.code != 0) {
              this.$message.error(res.data.msg)
              return
            }
            this.$emit('cancel')
          })
          .catch(err => {
            this.$message.warning(err.message)
          })
          .finally(() => {
            this.fullscreenLoading = false
          })

      }else{
        this.$message.warning('请选择样本数据')
      }


    },
    async dh() {
      try {
        let result = await this.getReaptePhone()
        //  console.log(result);
        if (result && result.data && result.data.data && result.data.data.length > 0) {
          this.beforePhone = result.data.data
          this.hasCheck = result.data.data
          this.checkPhone1 = this.hasCheck.join('、')
          this.dialogVisibleRepeat1 = true
        } else {
          this.creatTask()
        }
      } catch (err) {
        console.log(err)
      }
    },
    handleDialogClose() {
      this.dialogVisible = false
    },
    toOpen() {
      this.dialogVisible = false
      this.$router.push({
        name: `cost-settlement`
      })
    },
    onClickSubmit() {
       // 判断是否选择了线上结算且未开通
      let flag = false
      this.childVal.forEach(it=>{
        if(!it.settleMethod||it.settleMethod == 0) {
          flag = true
        }
      })
      if(this.$store.getters.settlementType===1 && flag) {
        this.dialogVisible = true
        return
      }
      let taskInfo = this.$refs.taskInfo
      this.$refs.taskInfo.validate(valid => {
        if (valid) {
          let mesFlag = false
          let beforeCheck = this.sampleStr.split('\n')
          //检查去重前的手机号正确与否
          let checkTempSampleStr = this.sampleStr.split('\n')
          console.log(checkTempSampleStr)
          // debugger
          if (checkTempSampleStr[0].length !== 0) {
            for (let index = 0; index < checkTempSampleStr.length; index++) {
              let phoneArr = checkTempSampleStr[index].split(/[，,]/g)
              // console.log(phoneArr);
              if (!(isMobile(phoneArr[0]) || isLandline(phoneArr[0]))) {
                mesFlag = true
                //手机号格式不正确时
                //获取指定删除下标记
                let idx = ''
                for (let i = 0; i < beforeCheck.length; i++) {
                  if (beforeCheck[i] == checkTempSampleStr[index]) {
                    idx = i
                  }
                }
                setTimeout(() => {
                  this.$message.warning(
                    `手机号：${checkTempSampleStr[index].split(/[，,]/g)[0]} 存在格式错误，已删除，请重新点击确认`
                  )
                }, 10)
                beforeCheck.splice(idx, 1)
              }
            }
          }
          if (mesFlag) {
            // this.$message.warning('当前输入框内存在格式错误的手机号，已自动删除，请重新输入')
            this.sampleStr = beforeCheck.join('\n')
            return
          }
          //验证好之后的只包含样本手机号的数组
          console.log(this.sampleArr)
          //拿到输入框的字符串
          let tempSampleStr = this.sampleStr

          let temp_sampleStr = this.sampleArr.map(el => {
            if (el[0]) {
              if (el[1]) {
                return `${el[0]},${el[1]}`
              } else {
                return `${el[0]}`
              }
            }
          })

          //去重后的只包含样本手机号的字符串
          this.sampleStr = uniq(temp_sampleStr).join('\n') // Array join之后会 变为 String

          tempSampleStr = tempSampleStr
            .split('\n')
            .map(item => {
              return item.replace(/，/g, ',')
            })
            .join('\n')
          if (tempSampleStr !== this.sampleStr) {
            //拿到重复的号码
            let newA = []
            for (var i = 0; i < temp_sampleStr.length; i++) {
              if (
                newA.indexOf(temp_sampleStr[i]) == -1 &&
                temp_sampleStr.indexOf(temp_sampleStr[i]) !== temp_sampleStr.lastIndexOf(temp_sampleStr[i])
              ) {
                newA.push(temp_sampleStr[i])
              }
            }
            //拿到重复的号码
            let repPhoneArr = newA.map(item => {
              return item.split(/[，,]/g)[0]
            })
            let samplePhone = this.sampleStr.replace(/\n/g, '、')
            let repeatArr = repPhoneArr
            this.repeatLen = repeatArr.length
            console.log(repeatArr)
            if (repeatArr.length > 3) {
              this.repeatPhone = repeatArr.slice(0, 3).join('、')
            } else {
              this.repeatPhone = repeatArr.join('、')
            }
            this.repeatAllArr = repeatArr
            this.dialogVisibleRepeat = true

            // this.$message.warning('已为您整理格式，并去除重复的样本手机号，同一问卷下，每个样本手机号只能添加一次。请重新提交')
            // 去重之后需要重新提交
          } else {
            // 不存在重复数据 执行网络请求
            if (this.childVal.length == 0) {
              this.$message.warning('当前未选择调查员，请选择后重试')
            } else {
              //有调查员 有样本电话时 先去检测电话重复
              //检查电话任务电话是否在问卷中重复
              this.dh()
            }
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleSubmit(){
      // 判断是否选择了线上结算且未开通
      let flag = false
      this.childVal.forEach(it=>{
        if(!it.settleMethod||it.settleMethod == 0) {
          flag = true
        }
      })
      if(this.$store.getters.settlementType===1 && flag) {
        this.dialogVisible = true
        return
      }
      let taskInfo = this.$refs.taskInfo
      this.$refs.taskInfo.validate(valid => {
        if (valid) {
          if (this.childVal.length == 0) {
            this.$message.warning('当前未选择调查员，请选择后重试')
          } else {
            //有调查员 有样本电话时 先去检测电话重复
            //检查电话任务电话是否在问卷中重复
            this.creatTask()
          }
        }
      })
    },
    getMore() {
      this.$refs.onlinePayServiceVisible.openDialog()
    },
    // 监听子组件传递过来的事件
    personDialog(val) {
      console.log(val)
      this.$emit('emitDialog', val)
    },
    selectionChangeEmit(data){
      this.tableData = data;
    }
  }
}
</script>

<style scoped lang="scss">
.flex-container {
  .phone-list {
    .phone-list-title {
      .phone-warning {
        font-size: 12px;
        color: red;
      }
    }
  }
}
.sample-component{
  padding: 0 8px;
  overflow: hidden;
  margin-top:16px;
}
.assignTask {
  .visitor-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 10px;
    margin-top: 10px;
  }
  .info {
    .el-form {
      // margin: 0 auto;
      .el-form-item {
        margin-bottom: 22px;
      }
      .el-form-input {
        // width: 400px;
      }
    }
    .font-style{
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 16px;
    }
  }
  .phone-info {
    padding: 0;
  }
  .task-info {
    border: none;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}
.submit-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: right;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  .footer-text {
    display: flex;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
    span.total{
      font-size: 22px;
      font-family: PingFangSC;
      font-weight: 500;
      color: #000;
      margin-left: 10px;
    }
    .flex{
      color: rgba(0, 0, 0, 0.65);
      font-size: 14px;
      font-family: PingFangSC;
      font-weight: 400;
      line-height: 32px;
    }
    .price-style {
      color: #000;
      font-weight: bold;
    }
    .parimy-btn {
      margin-left: 5px;
      @apply text-theme;
    }
    .icon-wrap {
      margin-left: 10px;
      .ico-tips {
        color: rgba(0,0,0,0.35);
      }
    }
  }
  .el-button {
    min-width: 88px;
  }
}
::v-deep .el-table {
  margin-top: 14px;
}
::v-deep .el-textarea__inner {
  height: 220px;
}
::v-deep .el-form-item__error {
  // margin-left: 150px;
}
.top {
  font-size: 16px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
}
.btn-footer {
  @apply flex items-center justify-end;
  // border-top: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
